import { render } from "./commonTable.vue?vue&type=template&id=751d963c&scoped=true"
import script from "./commonTable.vue?vue&type=script&lang=js"
export * from "./commonTable.vue?vue&type=script&lang=js"

import "./commonTable.vue?vue&type=style&index=0&id=751d963c&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751d963c"]])

export default __exports__